import { useLayoutEffect } from 'react';
import type { RefObject } from 'react';
import { useStoreApi } from '../../store';
import { observeSize } from '../../utils';

/** Keeps the store's pane size in sync with the root element. */
export const usePaneSize = (rootRef: RefObject<HTMLDivElement>): void => {
  const store = useStoreApi();
  useLayoutEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;
    return observeSize(root, (size) => store.getState().setPaneSize(size));
  }, [store, rootRef]);
};
